import React, { useEffect, useState } from "react";
import styles from "./Dashboard.module.scss";
import moment from "moment";
import { formatProfileAge } from "../../utils/age";
import { Table, Image, Row, Col } from "react-bootstrap";
import { useAuth } from "../../Context/AuthContext";
import { db } from "../../firebase";
import { useHistory } from "react-router-dom";

export default function WatchList() {
  
  const history = useHistory();
  const { isAdmin, isSuperAdmin,  currentUser, getUserInfoData } = useAuth();
  
  const [filteredProfiles, setFilteredProfiles] = useState([]);
  const [watchlistLoading, setWatchlistLoading] = useState(true);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // More comprehensive mobile detection
  const isMobile = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    const isMobileDevice = /iphone|ipad|ipod|android|blackberry|windows phone/g.test(userAgent);
    const isSmallScreen = windowWidth <= 1024;
    const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    
    return isMobileDevice || (isSmallScreen && isTouchDevice);
  };

  const isMobileView = isMobile();

  useEffect(() => {
    if (!currentUser?.uid) {
      setWatchlistLoading(false);
      setFilteredProfiles([]);
      return;
    }
    let cancelled = false;
    setWatchlistLoading(true);

    (async function load() {
      await fetchWatchList();
      if (!cancelled) setWatchlistLoading(false);
    })();

    return () => {
      cancelled = true;
    };
  }, [currentUser?.uid]);

  async function fetchWatchList() {
    const uid = currentUser?.uid;
    if (!uid) return;

    const document = await db.collection("watchlist").get();

    const watchlist = [];

    document.docs.forEach((doc) => {
      const subs = Array.isArray(doc.data()?.subscribers)
        ? doc.data().subscribers
        : [];
      if (subs.includes(uid)) {
        watchlist.push(doc.id);
      }
    });

    const response = await db.collection("player-profile").get();
    const data = [];

    response.docs.forEach((doc) => {
      if (watchlist.includes(doc.id)) {
        data.push({ id: doc.id, ...doc.data() });
      }
    });
    setFilteredProfiles(data);
  }

  if (watchlistLoading) {
    return (
      <div className={styles.watchlist}>
        <p>Watchlist</p>
        <p style={{ color: "#666", marginTop: "8px" }}>Loading…</p>
      </div>
    );
  }

  if (filteredProfiles.length === 0) {
    return (
      <div className={styles.watchlist}>
        <p>Watchlist</p>
        <p style={{ color: "#666", marginTop: "8px" }}>
          No players on your watchlist yet. Open a player profile and use Add to Watchlist.
        </p>
      </div>
    );
  }
  return (
    <div className={styles.watchlist}>
      <p>Watchlist</p>

      {isMobileView ? (
        // Mobile Layout - Simplified
        <div className={styles.mobileWatchlist}>
          {filteredProfiles &&
            filteredProfiles.map((item) => (
              <div
                key={item.id}
                className={styles.mobileWatchlistItem}
                onClick={() => {
                  history.push(`/player-profile/preview/${item.id}`);
                }}
              >
                <div className={styles.mobilePlayerImage}>
                  <Image
                    width="50px"
                    height="50px"
                    roundedCircle
                    src={item?.Headshot}
                    style={{
                      objectFit: "contain",
                    }}
                  />
                </div>
                <div className={styles.mobilePlayerInfo}>
                  <h4>
                    {item.FirstName} {item.LastName}
                  </h4>
                  <p>
                    {item.hometown_City}, {item.hometown_State_Country}
                  </p>
                </div>
              </div>
            ))}
        </div>
      ) : (
        // Desktop Layout - Full Table
        <Table
          responsive
          style={{
            borderRadius: "10px",
            overflow: "hidden",
            marginTop: "20px",
          }}
        >
          <tbody>
            {filteredProfiles &&
              filteredProfiles.map((item) => (
                <tr
                  style={{
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    history.push(`/player-profile/preview/${item.id}`);
                  }}
                  key={item.id}
                  className={styles.tableRow}
                >
                  <td>
                    <Row className="p-2">
                      <Col md={4}>
                        <Image
                          width="50px"
                          height="50px"
                          roundedCircle
                          src={item?.Headshot}
                          style={{
                            objectFit: "contain",
                          }}
                        />
                      </Col>
                      <Col md={8}>
                        <div className={styles.tablePersonInfo}>
                          <h4>
                            {item.FirstName} {item.LastName}
                          </h4>
                          {(item.Team === "Transfer Portal" && (isAdmin() || isSuperAdmin())) ? (
                                <h6>{item.Team}</h6>
                              ) : (item.Team !== "Transfer Portal" && <h6>{item.Team}</h6>)}
                          <p>
                            {item.hometown_City}, {item.hometown_State_Country}
                          </p>
                        </div>
                      </Col>
                    </Row>
                  </td>
                  <td>
                    <div className={styles.tableData}>
                      <p>Country</p>
                      <h4>{item.Country}</h4>
                    </div>
                  </td>
                  <td>
                    <div className={styles.tableData}>
                      <p>Position</p>
                      <h4>{item.Position}</h4>
                    </div>
                  </td>
                  <td>
                    <div className={styles.tableData}>
                      <p>Year</p>
                      <h4>{item.Year}</h4>
                    </div>
                  </td>
                  <td>
                    <div className={styles.tableData}>
                      <p>DOB</p>
                      <h4>{moment(item.DOB).format("l")}</h4>
                    </div>
                  </td>
                  <td>
                    <div className={styles.tableData}>
                      <p>Age</p>
                      <h4>{formatProfileAge(item.DOB, item.Age)}</h4>
                    </div>
                  </td>
                  <td>
                    <div className={styles.tableData}>
                      <p>AAU Team</p>
                      <h4>{item.aauTeam}</h4>
                    </div>
                  </td>
                  <td>
                    <div className={styles.tableData}>
                      <p>Affiliation</p>
                      <h4>{item.aauAffil}</h4>
                    </div>
                  </td>
                  <td>
                    <div className={styles.tableData}>
                      <p>Status</p>
                      <h4>
                        {item.Status}{" "}
                        {item.Status !== "Undecided" && item.committedTeam}
                      </h4>
                    </div>
                  </td>
                  <td
                    style={{
                      backgroundColor: "#000",
                    }}
                  >
                    <div className={styles.tableDataDark}>
                      <p>P.I. Score</p>
                      {/* <h4>{item.Piscore}</h4> */}
                      <h4>Coming Soon</h4>
                    </div>
                  </td>
                </tr>
              ))}{" "}
          </tbody>
        </Table>
      )}
    </div>
  );
}
